module.exports = __webpack_public_path__ + "img/building.e4427227.png";